/**
 * 复制对象(深)
 * @param {*} value 被复制的对象
 * @returns {*} 对象副本 
 */
function getCopy(value: any): any {
    if (value instanceof Object) {
        return JSON.parse(JSON.stringify(value));
    } else {
        return value;
    }
}

/**
 * 对象去空（浅）
 * @param obj 
 * @returns 加工后的对象
 */
function getClearBlankParas(obj: any): any {
    if (obj instanceof Object) {
        let ret = {};
        for (const item in obj) {
            if (obj[item] || obj[item] === 0 || obj[item] === false) {
                ret[item] = obj[item];
            }
        }
        return ret;
    } else {
        return obj;
    }
}
function clearBlankArray(obj: any): any {
    if (obj instanceof Object) {
        for (const item in obj) {
            if (obj[item] instanceof Array && obj[item].length === 0) {
                obj[item] = null;
            }
        }
        return obj;
    } else {
        return obj;
    }
}
/** 遍历对象 */
function forEach(obj: any = {}, callback: (value?: any, key?: string) => void) {
    for (let i in obj) {
        if (obj[i] !== undefined) {
            callback(obj[i], i);
        }
    }
}

/** 加载JS */
function requireJS(file: string, callback: () => {}): Promise<void> {
    return new Promise<void>((reject: () => void) => {
        var script = document.getElementsByTagName('script')[0];
        var newjs = document.createElement('script');

        newjs.onload = function () {
            reject();
        };

        newjs.src = file;
        script.parentNode.insertBefore(newjs, script);
    });
}

/** 加载CSS */
function requireCSS(file: string): Promise<void> {
    return new Promise<void>((reject: () => void) => {
        var link = document.getElementsByTagName('link')[0];
        var newlink = document.createElement('link');

        newlink.onload = function () {
            reject();
        };

        newlink.href = file;
        link.parentNode.insertBefore(newlink, link);
    });
}

export default {
    getClearBlankParas,
    clearBlankArray,
    getCopy,
    requireCSS,
    requireJS,
    forEach
};


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/utils/kit/JSObject/index.ts